export default __webpack_public_path__ + "static/media/449East-2BR.d6343bad.svg";